

import {useContext} from 'react';

import ErrorContext from '../context/ErrorContext';
import Swal from 'sweetalert2'

import {
    getAll,
    getAllByUser,
    create,
    getOne
} from "services/ErrorService"

export function useError(){

 const {
   allErrors, 
   setAllErrors,
   allErrorsByUser,
   setAllErrosByUser,
   error,
   setError,
   message,
   setMessage,
   loading,
   setLoading
  } = useContext(ErrorContext);

 const getAllErrors = async () => {
   try{
     const response = await getAll();
     setAllErrors(response)
     return response
   }catch(err){
    const {data, status} = err.response;
    setMessage({message: data.message, status});
   }
 }

 const getAllUser = async () => {
   setLoading(true);
   try{
     const response = await getAllByUser();
     setAllErrosByUser(response)
     setLoading(false);
     return response
   }catch(err){
      setLoading(false);
      const {data, status} = err.response;
      setMessage({message: data.message, status});
   }
 }

 const createError = async ({error}) => {
  try{
    const {message} = await create({error}); 
    setMessage(state => ({...state, message}))
    Swal.fire({
        icon:'success',
        title: 'Éxito!!!',
        text: message,
    })
    await getAllErrors();
    await getAllUser();
    return ''
  }catch(err){
    const {data, status} = err.response
    setMessage({message: data.message, status});    
    Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: data.message,
    })
    return status
  }
 }
 const getOneError = async ({id}) => {
   setLoading(true);
  try{
    const error = await getOne({id}); 
    setError({...error});
    setLoading(false);
    return ''
  }catch(err){
    const {data, status} = err.response
    if(data.message === 'El error no se encuentra'){
       setError({});
    }else{
      setMessage({message: data.message, status});  
      Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: data.message,
      })
    }
    setLoading(false);
    return status

  }
 }

 

 return {allErrors, getAllErrors, allErrorsByUser, getAllUser, createError, status: message.status, loading, message, error, getOneError}
}